import React, { useMemo } from "react";
import { INITIAL_GET_PARAMS } from "../../../enums/generalEnums";
import { ACTIVE } from "../../../enums/statusEnums";
import { useCollabCreators } from "../../../hooks/apiHooks/useCollabCreators";
import { router } from "@inertiajs/react";
import { arrayRandomizer } from "../../../helpers/arrayHelper";
import { TopCreatorsLayout } from "./TopCreatorsLayout";

export const SimilarCreators = ({ tags, contentInterest, collabInterest, selectedCreatorId }) => {
  const { data: creators, isLoading } = useCollabCreators('similar', {
    ...INITIAL_GET_PARAMS,
    per_page: 50,
    status: ACTIVE,
    filters: {
      collab_interest: collabInterest ?? [],
      content_interest: contentInterest ?? [],
      category_values: tags ?? []
    }
  });

  const renderCreators = useMemo(() => {
    const currentList = creators?.data;
    const filterList = currentList?.filter((item) => item?.name !== selectedCreatorId);
    return arrayRandomizer(filterList, 8);
  }, [creators, selectedCreatorId]);

  return (
    <TopCreatorsLayout
      creators={renderCreators}
      isLoading={isLoading}
      handleViewAll={() => router.visit('/collab-creators')}
      tagType={'Similar'}
    />
  );
};